export const setPopoverDataStatus = (type, status) => {
  if (type === 'RECIPE' && (status === 'START' || status === 'FINISH')) {
    return 'start';
  }

  if (type === 'TRANSFORMATION' && (status === 'START' || status === 'FINISH')) {
    return 'finishTransformation';
  }

  return 'waiting';
};
